/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ZendeskCredentials,
  ZendeskCredentials$inboundSchema,
  ZendeskCredentials$Outbound,
  ZendeskCredentials$outboundSchema,
} from "./zendeskcredentials.js";
import {
  ZendeskData,
  ZendeskData$inboundSchema,
  ZendeskData$Outbound,
  ZendeskData$outboundSchema,
} from "./zendeskdata.js";

export type PublicZendeskConnection = {
  provider: "zendesk";
  data: ZendeskData;
  credentials: ZendeskCredentials;
};

/** @internal */
export const PublicZendeskConnection$inboundSchema: z.ZodType<
  PublicZendeskConnection,
  z.ZodTypeDef,
  unknown
> = z.object({
  provider: z.literal("zendesk"),
  data: ZendeskData$inboundSchema,
  credentials: ZendeskCredentials$inboundSchema,
});
/** @internal */
export type PublicZendeskConnection$Outbound = {
  provider: "zendesk";
  data: ZendeskData$Outbound;
  credentials: ZendeskCredentials$Outbound;
};

/** @internal */
export const PublicZendeskConnection$outboundSchema: z.ZodType<
  PublicZendeskConnection$Outbound,
  z.ZodTypeDef,
  PublicZendeskConnection
> = z.object({
  provider: z.literal("zendesk"),
  data: ZendeskData$outboundSchema,
  credentials: ZendeskCredentials$outboundSchema,
});

export function publicZendeskConnectionToJSON(
  publicZendeskConnection: PublicZendeskConnection,
): string {
  return JSON.stringify(
    PublicZendeskConnection$outboundSchema.parse(publicZendeskConnection),
  );
}
export function publicZendeskConnectionFromJSON(
  jsonString: string,
): SafeParseResult<PublicZendeskConnection, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PublicZendeskConnection$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PublicZendeskConnection' from JSON`,
  );
}
